import { useEffect, useState } from 'react';
import { useWallet } from './wallet';

export const useAccountLoginType = (): AccountLoginType => {
    const { logged, connected } = useWallet();
    const [loginType, setLoginType] = useState('UnConnected' as AccountLoginType);

    useEffect(() => {
        if (logged) {
            setLoginType('Logged');
            return;
        }
        if (connected) {
            setLoginType('Connected');
            return;
        }
        setLoginType('UnConnected');
    }, [connected, logged]);
    return loginType;
};
